import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=1fd46606"
import script from "./ProductSearch.vue?vue&type=script&lang=ts"
export * from "./ProductSearch.vue?vue&type=script&lang=ts"
import style0 from "./ProductSearch.vue?vue&type=style&index=0&id=1fd46606&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports